export default "__VITE_ASSET__GnCHyLn9__"